import {useEditableControls} from '@chakra-ui/react';
import type {PropsWithChildren} from 'react';

export const EditableOff = (props: PropsWithChildren) => {
  const {isEditing} = useEditableControls();

  return isEditing ? null : <>{props.children}</>;
};
